import wpAjax from "../helpers/axios";
import axios from "axios";
import { isPostalCode } from "validator";

document.querySelectorAll(".locations-search").forEach((module) => {
  const form = module.querySelector("form");
  const errorEl = form.querySelector(".error");

  // Search for location by postcode
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const postcode = form.querySelector(
      'input[name="locations_search_postcode"]',
    ).value;

    // Reset error messages
    errorEl.innerHTML = "";
    errorEl.classList.add("hidden");

    if (isPostalCode(postcode, "GB")) {
      // Postcode is valid, so get the coordinates of it
      const coords = await getPostcodeLatLng(postcode);

      if (coords) {
        runLocationsSearch(coords);
      } else {
        // Postcode coords cannot be found
        errorEl.innerHTML =
          "Sorry, your postcode's location could not be found.";
        errorEl.classList.remove("hidden");
      }
    } else {
      // Postcode is not valid for UK, so show error
      errorEl.innerHTML = "Sorry, your postcode is invalid.";
      errorEl.classList.remove("hidden");
    }
  });

  // Search for locations by browser location
  module
    .querySelector(".js-locations-search-geolocate")
    .addEventListener("click", () => {
      module.classList.add("is-loading");

      // Get user's co-ords from browser geolocation API
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const coords = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          runLocationsSearch(coords);
        },
        (error) => {
          // Geolocation failed
          errorEl.innerHTML = "Sorry, we couldn't locate you right now.";
          errorEl.classList.remove("hidden");
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        },
      );
    });
});

const runLocationsSearch = async (coords) => {
  const module = document.querySelector(".locations-search");
  module.classList.add("is-loading");

  // Make request to backend
  const { data } = await wpAjax.post("", {
    action: "ajax_get_location_cards_by_coords",
    lat: coords.lat,
    lng: coords.lng,
  });

  // Replace html
  module.querySelector(".js-locations-search-items").innerHTML = data.html;
  module.classList.remove("is-loading");

  // Refresh scrolltrigger
  // ScrollTrigger.refresh();

  // Reinit tooltips
  // reInitTooltips();

  // Remove fade-in on scroll classes
  // removeFadeInOnScrollClasses(container);
};

async function getPostcodeLatLng(postcode) {
  if (!postcode) return false;

  try {
    const { data } = await axios.get(
      `https://api.postcodes.io/postcodes/${postcode}`,
    );
    if (data.status === 200 && data.result.latitude && data.result.longitude) {
      return {
        lat: data.result.latitude,
        lng: data.result.longitude,
      };
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return false;
  }
}
